/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import ManageButton from './manage-button';
import { SWITCHER_TAB_BUTTON_PREFIX, SWITCHER_TAB_PANEL_PREFIX } from './utils';

const styles = cssMap({
	wrapper: {
		boxSizing: 'border-box',
		height: '100%',
		minWidth: 0,
		flex: 1,
		overflowY: 'auto',
		width: '343px',
		// workaround for WAC global typo overrides issue
		// https://product-fabric.atlassian.net/browse/CXP-3312
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
		'img,svg': {
			marginBottom: 0,
		},
	},
	body: {
		minHeight: `calc(100% - 60px)`,
	},
	footer: {
		display: 'flex',
		boxSizing: 'border-box',
		margin: '0 auto',
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		position: 'sticky',
		bottom: 0,
		alignItems: 'center',
		justifyContent: 'center',
		borderTop: `1px solid ${token('color.border')}`,
	},
	activeOrg: {
		height: `calc(100% + 16px)`,
	},
});

type SwitcherWrapperProps = {
	children: React.ReactNode;
	activeOrgId?: string;
};

class SwitcherWrapper extends React.Component<SwitcherWrapperProps> {
	render() {
		const { children, activeOrgId } = this.props;

		const manageButton = React.Children.toArray(children).filter(
			(child) => React.isValidElement(child) && React.Children.only(child).type === ManageButton,
		);
		const items = React.Children.toArray(children).filter(
			(child) => React.isValidElement(child) && React.Children.only(child).type !== ManageButton,
		);

		const tabProps = activeOrgId
			? {
					id: `${SWITCHER_TAB_PANEL_PREFIX}-${activeOrgId}`,
					role: 'tabpanel',
					'aria-labelledby': `${SWITCHER_TAB_BUTTON_PREFIX}-${activeOrgId}`,
				}
			: {};

		return (
			<div {...tabProps} css={[styles.wrapper, activeOrgId && styles.activeOrg]}>
				<div css={styles.body}>{items}</div>
				{manageButton.length ? <footer css={styles.footer}>{manageButton}</footer> : null}
			</div>
		);
	}
}

export default SwitcherWrapper;
